<!--
购物车

使用说明：

<CartItem
    :cart="{Cart}"
    @selectedChange="(cart, isSelected)=>{}"
/>

Cart={
        product: {
            productId: 2,
            name: '好酷商品好酷商品好酷商品好酷商品好酷商品好酷商品好酷商品好酷商品好酷商品好酷商品好酷商品好酷商品',
            image: 'https://img12.360buyimg.com/mobilecms/s250x250_jfs/t20764/211/1906502952/178961/7db1a8c0/5b3c39c5Nd16d5478.jpg',
            skuName: '高级',
            price: 1000
        },
        amount: 2,
        isSelected: false, //是否选择
        valid: true //是否缺货
    }
-->
<template>
    <div class="cart-wrap">
        <CheckboxButton class="cart-select-btn" :value="cart.isSelected" @onChange="selectedChange" />
        <Icon class="image" :img="cart.product.image | asProductImage" />
        <div class="info-box">
            <div class="title">{{cart.product.name}}</div>
            <div class="sku">{{cart.product.skuName}}</div>
            <div class="price">{{cart.product.price}} {{pointUnit}} <span class="invalid-tip" v-if="!cart.valid">缺货</span>  </div>
        </div>
        <!-- 数量调整 -->
        <div class="cart-amount-actions" v-if="cart.steps.length <= 0">
            <Icon :img="require('../../assets/icon-cart-less.png')" class="change-btn minute-btn" @click.native="amountChange(-1)"/>
            <input class="amount-input" type="number" @blur="checkAmount" v-model.number="amount">
            <Icon :img="require('../../assets/icon-cart-more.png')" class="change-btn plus-btn" @click.native="amountChange(+1)"/>
        </div>
        <div class="cart-amount-actions" v-else>
            <Icon :img="require('../../assets/icon-cart-less.png')" class="change-btn minute-btn" @click.native="stepBack"/>
            <input class="amount-input" type="number" @blur="checkAmount" v-model.number="amount" disabled>
            <Icon :img="require('../../assets/icon-cart-more.png')" class="change-btn plus-btn" @click.native="stepForward"/>
        </div>
    </div>
</template>

<script>
import store from '../../api/store'

var actionTimer;

export default {
  props: ["cart"],
  components: {},
  data() {
    if(this.cart.steps.length > 0){
      var stepIndex = 0;
      var amount = this.cart.steps[0];

      for (var i = 0;i < this.cart.steps.length; i++) {
        var s = this.cart.steps[i];
        if(s == this.cart.amount){
          stepIndex = i;
          amount = s;
        }
      }
      return {
        amount,
        pointUnit: store.loginedUser.config.pointName,
        stepIndex
      };
    }else{
      return {
        amount: this.cart.amount,
        pointUnit: store.loginedUser.config.pointName
      };
    }
    
  },
  watch: {
    amount: function(v) {
      if(!!v){
        this.checkAmount();
      }
    }
  },
  methods: {
    selectedChange(v) {
      this.$emit("selectedChange", this.cart, v);
    },
    amountChange(v) {
      if (v < 0 && this.amount <= 1) {
        return;
      }
      if (v > 0 && this.amount >= 50) {
        return;
      }
      this.amount += v;
      this.$emit("amountChange", this.cart, this.amount);
    },
    stepBack(){
      if(this.stepIndex <= 0){
        return ;
      }

      this.stepIndex --;
      this.amount = this.cart.steps[this.stepIndex];
      clearTimeout(actionTimer);
      actionTimer = setTimeout(()=>{
        this.$emit("amountChange", this.cart, this.amount);
      }, 100);
    },
    stepForward(){
      if(this.stepIndex >= this.cart.steps.length - 1){
        return ;
      }

      this.stepIndex ++;
      this.amount = this.cart.steps[this.stepIndex];
      clearTimeout(actionTimer);
      actionTimer = setTimeout(()=>{
        this.$emit("amountChange", this.cart, this.amount);
      }, 100);
    },
    checkAmount() {
      if (this.amount <= 0 || this.amount > 50) {
        setTimeout(() => {
          this.amount = 1;
        }, 100);
        this.$toast("商品数量只能填写1~50");
        return;
      }
      
      clearTimeout(actionTimer);
      actionTimer = setTimeout(()=>{
        this.$emit("amountChange", this.cart, this.amount);
      }, 100);
      
    }
  }
};
</script>

<style lang="less">
@activeColor: #ff7e5f;
@diactiveColor: #e6e6e6;

.cart-wrap {
  width: 92vw;
  height: 29.866vw;
  margin: 0 auto;
  border-bottom: 1px solid #e6e6e6;
  position: relative;
  z-index: 2;

  .cart-select-btn {
    position: absolute;
    z-index: 2;
    top: 13.33vw;
  }

  .image {
    position: absolute;
    z-index: 2;
    top: 2.13vw;
    left: 7.33vw;
    width: 25vw;
    height: 25vw;
  }

  .info-box {
    position: absolute;
    z-index: 2;
    top: 2.13vw;
    left: 35.466vw;
    width: 56vw;

    .title {
      font-size: 3.33vw;
      line-height: 1.5em;
      height: 3em;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: normal;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      margin-bottom: 2.93vw;
    }

    .sku {
      color: #999999;
      font-size: 2.93vw;
      line-height: 1.2em;
      margin-bottom: 6vw;
      width: 100%;
      overflow:hidden;
      text-overflow:ellipsis;
      white-space:nowrap
    }

    .price {
      color: #3b3b3b;
      font-size: 3.466vw;
      line-height: 1em;

      .invalid-tip{
        color: red;
      }
    }
  }

  .cart-amount-actions {
    position: absolute;
    z-index: 2;
    right: 0;
    bottom: 1.733vw;
    font-size: 0;

    .change-btn {
      @size: 5.33vw;
      width: @size;
      height: @size;
      vertical-align: top;
      
      &.minute-btn{
        @size: 4.9vw;
        width: @size;
        height: @size;
      }
    }

    .amount-input {
      line-height: 5.33vw;
      font-size: 3.4vw;
      color: #3c3c3c;
      width: 9vw;
      text-align: center;
      margin: 0;
      padding: 0;
      background: #f7f7f7;
      border: none;
      border-radius: 0.26vw;
      margin: 0 2vw;
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/components/orders/CartItem.vue